import React, { useEffect, useState } from "react";
import { AiFillStar } from "react-icons/ai";
import check from "../assets/bluetick.jpg";
import bottle from "../assets/articale/breathe-top-image.png";

const Recommended = () => {
  const [vid, setVid] = useState(null);
  useEffect(() => {
    function replaceVidPlaceholder() {
      if (window?.clickmagick_cmc && window?.clickmagick_cmc?.vid) {
        setVid(window?.clickmagick_cmc?.vid);
      } else {
        setTimeout(replaceVidPlaceholder, 200);
      }
    }
    replaceVidPlaceholder();
  }, []);
  return (
    <div className="sticky top-5">
      <div className="border border-black rounded p-4  flex flex-col items-center bg-white">
        <h2 className="text-[25px] font-semibold text-center mb-1.5">
          Recommended:
        </h2>
        <div className="flex items-center justify-center mb-1.5">
          {[...Array(5)].map((_, i) => (
            <AiFillStar key={i} className="w-5 h-5 text-yellow-400" />
          ))}
        </div>
        <div className="text-sm mb-4">
          <span className="font-semibold">{"4.7"}</span> {"/"}{" "}
          <span className="text-gray-600">{"3,791 Reviews"}</span>
        </div>
        <div className="border-t border-gray-300 w-full mb-4"></div>
        <h3 className="text-blue-600 font-bold text-center mb-3 text-lg">
          Herbal Tea Therapy <br /> Breathe
        </h3>
        <div className="w-full space-y-2 mb-4">
          {[
            "Extremely effective against asthma and COPD",
            "Clears accumulated mucus that causes discomfort",
            "Improves immune system for building up healthy lungs",
            "Better breathing in just 30 days or your money back",
          ].map((text, index) => (
            <div key={index} className="flex items-start gap-2">
              <img src={check} alt="check" className="w-5" draggable="false" />
              <span className="text-[13px] leading-tight">{text}</span>
            </div>
          ))}
        </div>
        <div className="flex justify-center mb-4">
          <img
            src={bottle}
            alt="MedLife Mullein Extract bottle and packaging"
            className=" object-contain h-64"
            draggable="false"
          />
        </div>
        {vid ? (
          <a
            id="cta-button"
            href={`https://specialoffer.breatheagain.io/?aff=HerbalTeaTherapy&cid=${vid}`}
            rel="noopener noreferrer"
          >
            <button className="bg-[#ff9900] text-white py-2.5 px-6 rounded-full shadow-lg text-sm font-semibold hover:bg-[#ff9900] hover:shadow-sm hover:bg-opacity-90 ease-in-out transition hover:translate-y-[2px] flex items-center gap-2">
              <span>{"Check Availability"}</span>
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="white"
                >
                  <polygon points="11.293 4.707 17.586 11 4 11 4 13 17.586 13 11.293 19.293 12.707 20.707 21.414 12 12.707 3.293 11.293 4.707" />
                </svg>
              </span>
            </button>
          </a>
        ) : (
          <a
            id="cta-button"
            href={`https://specialoffer.breatheagain.io/?aff=HerbalTeaTherapy&cid=${vid}`}
            rel="noopener noreferrer"
          >
            <button className="bg-[#ff9900] text-white py-2.5 px-6 rounded-full shadow-lg text-sm font-semibold hover:bg-[#ff9900] hover:shadow-sm hover:bg-opacity-90 ease-in-out transition hover:translate-y-[2px] flex items-center gap-2">
              <span>{"Check Availability"}</span>
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="white"
                >
                  <polygon points="11.293 4.707 17.586 11 4 11 4 13 17.586 13 11.293 19.293 12.707 20.707 21.414 12 12.707 3.293 11.293 4.707" />
                </svg>
              </span>
            </button>
          </a>
        )}
      </div>
    </div>
  );
};
export default Recommended;
